import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-attributes-ontology',
  templateUrl: './attributes-ontology.component.html',
  styleUrls: ['./attributes-ontology.component.css']
})
export class AttributesOntologyComponent implements OnInit {

  @Input() entityData: any;
  url: string;
  token: any = ApiConstants.blobSasToken;
  transformedAttributeData: any = [];
  datePicker = new FormControl(new Date());
  currentStatHistoryPage: number = 1;
  devicesOnline: boolean = true;
  private _activeEntityDetailsSubscription: Subscription;
  private _subscription: Subscription;
  private _tenantConfig: any;
  constructor(
    private _service: ServicecallService,
    private _entityService: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _widgetService: WidgetsServiceService,
    private _dataSer: DataService
  ) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this.activeEntityDetails(1);
      }
    });
  }

  ngOnInit(): void {
    this._tenantConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : null;
    this.url = this.getUrlForCategory();
    if(this.entityData?.category === 'Product Box')
      this.activeEntityDetails();
    else this.devicesOnline = false;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._activeEntityDetailsSubscription?.unsubscribe();   
  }

  activeEntityDetails(pageNo?: number) {
    this.currentStatHistoryPage = pageNo ? pageNo : this.currentStatHistoryPage;
    const startDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999);
    const endDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999);
    const requestData = {
      siteId: this._service.getSiteId(),
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityData?._id,
    };
    this._activeEntityDetailsSubscription = this._widgetService.activeEntityDetails(requestData,this.currentStatHistoryPage).subscribe({
      next: (result: any) => {
          if (result['status'] && result['response']['data']?.length) {
            if (result['response']?.['data']?.[0]?.attributes?.length){
            const attributeCheckValue = result['response']?.['data']?.[0]?.attributes?.find((item: any) => item.attributeName === 'Webcam 3');
            if(attributeCheckValue?.attributeValue === '1.0'){
              this.devicesOnline = true;
            }
            else{this.devicesOnline = false;}
            }
          }
      }, error: (error) => {
        if (error) {
          if (error?.response?.message)
          this._service.toasterService({ type: 'error', msg: error?.response?.message });
        }
      }
    });
  }

  getUrlForCategory(){
    let profileDetails = this._tenantConfig.profile.find((item: any) => item.category === this.entityData?.category);
    return profileDetails?.ontologyUrl
  }
}
